import React from "react";
import _ from "lodash";

import Rendition from "../../types/Rendition";

export interface ImgProps {
    renditions: Rendition[];
    className?: string;
    alt?: string;
    style?: any;
    size?: string;
}

export const Img = (props: ImgProps) => {
    if (!props.renditions || !props.renditions.length) {
        return null;

    }
    const srcset = _.map(props.renditions, (rendition) => {
        return `${rendition.url} ${rendition.width}w`;
    });

    return (
        <img
            className={props.className}
            src={props.renditions[0].url}
            sizes={props.size}
            srcSet={srcset.join(",")}
            alt={props.alt}
            style={props.style} />
    );
};

export default Img;
